module.exports = __webpack_public_path__ + "static/media/btn_point_front_pre.b5490781.svg";